import React, { useCallback } from 'react';
import cn from 'classnames';

import { useSelector, useDispatcher } from 'app/store/utils/redux/hooks';
import Analytics from 'app/lib/Analytics/Analytics';

import styles from './Drawer.module.css';

interface IDrawerProps {}

const Drawer: React.FC<IDrawerProps> = (props) => {
  const isOpen = useSelector((state) => state.drawer.isOpen);
  const isReady = useSelector((state) => state.card.meta.status === 'ready');
  const actions = useDispatcher();

  const handleHideDrawer = useCallback(() => {
    actions.drawer.setOpen(false);
  }, [actions.drawer]);

  const handleClickHome = useCallback(() => {
    Analytics.track().tappedHamburgerVisitWebsite();
  }, []);
  const handleClickTerms = useCallback(() => {
    Analytics.track().tappedHamburgerTermsAndConditions();
  }, []);
  const handleClickDownload = useCallback(() => {
    Analytics.track().tappedHamburgerDownloadApp();
  }, []);

  return (
    <div className={cn(styles.drawer, { [styles.open]: isOpen, [styles.init]: !isReady })}>
      <div className={cn(styles.cover, { [styles.init]: !isReady })} onClick={handleHideDrawer} aria-hidden="true" />
      <nav>
        <div className={styles.header}>
          <div>Menu</div>
        </div>
        <div className={styles.item}>
          <a onClick={handleClickHome} href="https://www.cardsnacks.com/">Website</a>
        </div>
        <div className={styles.item}>
          <a onClick={handleClickTerms} href="https://www.cardsnacks.com/terms-of-service">Terms &amp; Conditions</a>
        </div>
        <div className={styles.item}>
          <a
            onClick={handleClickDownload}
            rel="noreferrer"
            href="https://cardsnacks.go.link/lBq3x"
            target="_blank"
          >
            Download the App
          </a>
        </div>
      </nav>
    </div>
  );
};

export default Drawer;
